<div class="fixed bottom-10 right-10 z-[1000] flex flex-col items-end">
  <div id="hubSpotChat" [ngClass]="{ 'hide-chat': !showChat }"></div>

  <div
    #box="dialogBox"
    class="reative w-fit text-2xl py-2 bg-primary text-white rounded-full flex items-center justify-center shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all duration-100 cursor-pointer"
    [ngClass]="{ 'px-6': !showChat, 'px-3': showChat }"
    dialogBox
    dialogPosition="above"
    dialogAlign="right"
    [dialogDisable]="showChat || !(items?.length > 0 || articles?.length > 0)"
    [dialogTitle]="boxTitle"
    [dialogTemplate]="
      items?.length > 0 || articles?.length > 0 ? guideTemplate : null
    "
    [dialogFooter]="footer"
    (click)="
      !(items?.length > 0 || articles?.length > 0) && !showChat
        ? openLiveChat($event)
        : closeLiveChat($event)
    "
  >
    @if (unreadCount > 0 && !showChat && box.dialogRef == null) {
      <div
        class="absolute w-4 h-4 flex items-center justify-center text-sm rounded-full bg-secondary top-0 right-0"
      ></div>
    }
    @if (!showChat) {
      <confect-icon
        icon="help_outlined"
        class="text-xl font-bold select-none"
        iconClass="text-3xl mr-1"
        >Help</confect-icon
      >
    } @else {
      <confect-icon
        icon="clear"
        class="text-xl font-bold select-none"
        iconClass="text-3xl"
      />
    }
  </div>
</div>
<ng-template #guideTemplate>
  <div class="overflow-y-auto 2xl:w-[450px] w-[350px] max-h-[50vh] px-3">
    <div class="flex flex-col gap-8 mb-10">
      @if (articles != null && articles.length > 0) {
        <div class="flex flex-col items-center gap-5">
          <div class="text-xl flex items-center justify-between w-full">
            <div class="text-gray-900">
              {{ inspiration ? "Inspirational" : "Help" }} Articles
            </div>
            <div
              class="text-base text-primary hover:text-primary-700 cursor-pointer"
              (click)="openArticle('https://academy.confect.io/')"
            >
              View More
            </div>
          </div>
          <div class="flex flex-col w-full gap-5">
            @for (article of articles; track article.link) {
              <div
                class="text-sm group cursor-pointer flex items-center w-full"
                (click)="openArticle(article.link)"
              >
                <div class="flex items-center justify-between w-full pl-2">
                  <div class="flex flex-col gap-1">
                    <div
                      class="text-base text-gray-700 group-hover:text-gray-900"
                    >
                      {{ article.title }}
                    </div>
                    <div
                      class="text-xs text-gray-500 group-hover:text-gray-700"
                    >
                      {{ article.subtitle }}
                    </div>
                  </div>
                  <confect-icon
                    icon="open_in_new"
                    iconClass="text-xl ml-2 group-hover:text-primary-400"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      }

      @if (items != null && items.length > 0) {
        <div class="flex flex-col gap-5">
          <div class="text-xl flex items-center justify-between w-full">
            <div class="text-gray-900">Tips</div>
          </div>
          <div
            class="flex flex-col items-center gap-2 bg-slate-100 rounded-md px-2 py-3"
          >
            @for (item of items; track item.key) {
              <div
                class="text-sm group cursor-pointer flex items-center w-full"
                (click)="activateAction(item, $event)"
              >
                <div class="flex items-center justify-between w-full pl-2">
                  <div class="flex flex-col">
                    <div
                      class="text-base text-gray-700 group-hover:text-gray-900"
                    >
                      {{ item.display }}
                    </div>
                  </div>
                  <confect-icon
                    icon="arrow_forward"
                    iconClass="text-sm mr-2 group-hover:text-primary"
                  />
                </div>
              </div>
            }
          </div>
        </div>
      }
    </div>
  </div>
</ng-template>
<ng-template #footer>
  <div class="grid grid-cols-2 w-full my-2">
    <div
      class="flex flex-col items-center group cursor-pointer"
      (click)="openArticle('https://academy.confect.io/')"
    >
      <confect-icon
        icon="book"
        iconClass="text-3xl text-slate-600 group-hover:text-primary"
      />
      <div class="text-xs text-slate-600 group-hover:text-primary">Academy</div>
    </div>
    <div
      class="flex flex-col items-center group cursor-pointer"
      (click)="openLiveChat($event)"
    >
      <confect-icon
        icon="sms_chat"
        iconClass="text-3xl text-slate-600 group-hover:text-primary"
        class="relative"
      >
        @if (unreadCount > 0) {
          <div
            class="absolute w-4 h-4 flex items-center justify-center text-sm rounded-full bg-secondary top-0 -right-3"
          ></div>
        }
      </confect-icon>
      <div class="text-xs text-slate-600 group-hover:text-primary">
        Live Chat
      </div>
    </div>
  </div>
</ng-template>
